import React from 'react';
import { ActivityModalProvider } from './ActivityModalProvider';
import { AddActivityModalContainer } from './AddActivityModalContainer';
type Props = {
  handleAddActivity: (activities: any[]) => void;
};
export const AddActivityModal = ({ handleAddActivity }: Props) => {
  return (
    <ActivityModalProvider>
      <AddActivityModalContainer handleAddActivity={handleAddActivity} />
    </ActivityModalProvider>
  );
};
